<script>
    import { Router, Route, navigate } from "svelte-routing";
    import { onMount } from "svelte";
    import { getQueryParameterByName } from "@/lib/utils";
    import {classes} from "@/stores/classes"

    import Fallback from "@/pages/Fallback.svelte";
    import Header from "@/components/Header.svelte";
    import Footer from "@/components/Footer.svelte";

    let scrollY;
    let outerHeight;
    let header;

    onMount(() => {
        // Scroll to the Element with the ID in the URL Hash
        if (getQueryParameterByName("scrollto")) {
            setTimeout(function () {
                let element = document.getElementById(
                    getQueryParameterByName("scrollto"),
                );
                if (element) {
                    element.scrollIntoView();
                }
            }, 1000);
        }
    });

    const appearSections = () => {
        let appearObserver = new IntersectionObserver(appearOnIntersect, {
            threshold: 0,
        });

        Array(...document.querySelectorAll(".appear")).forEach(
            (odometerElement) => {
                odometerElement.innerHTML;
                appearObserver.observe(odometerElement);
            },
        );
    };

    const appearOnIntersect = (entries) => {
        entries.forEach((entry) => {
            entry.isIntersecting
                ? entry.target.classList.add("inview")
                : entry.target.classList.remove("inview");
        });
    };

    const componentInternallyLoaded = () => {
        appearSections();
    };
</script>

<svelte:window bind:scrollY bind:outerHeight />

<Router>
    <main class="w-full flex flex-col min-h-screen relative bg-background-500 max-w-[2000px] mx-auto {$classes}">
        <Header bind:this={header} />

        <main class="min-h-screen overflow-x-hidden">
            <div>
                <Route to="/*">
                    <Fallback on:loaded={componentInternallyLoaded} />
                </Route>
            </div>
        </main>

        <Footer />
    </main>
</Router>